<template>
    <facet-template
        :show-clear-link="isFiltered"
        :title="title"
        v-bind="$attrs"
        @clear="clearAllColors"
    >
      <span slot="facetLabel">
            {{ title }}
            <small class="font-italic font-weight-normal" v-if="value.length>0">
                ({{ value.length }})
            </small>
        </span>
        <b-container>
            <b-row>
                <b-col cols="12" class="p-0 ml-2 mb-0">
                    <div class="color-list d-flex flex-row flex-wrap">
                        <color-swatch
                            v-for="color in normalizedColors"
                            :key="color.name"
                            :name="color.name"
                            :hex="color.hex"
                            :selected="isColorSelected(color)"
                            @click.native="toggleColor(color)"
                        />
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </facet-template>
</template>

<script>
import FacetTemplate from "./FacetTemplate";
import _ from "lodash";
import ColorSwatch from "@carsaver/color-swatch";
import { BContainer, BRow, BCol } from "bootstrap-vue";

export default {
    components: {
        ColorSwatch,
        FacetTemplate,
        BContainer,
        BRow,
        BCol
    },

    props: {
        value: {
            type: Array,
            required: true
        },
        available: {
            type: Array,
            required: true
        },
        title: {
            type: String,
            required: true
        }
    },

    computed: {
        normalizedColors() {
            const colorArray = this.available.slice();
            const indexPos = colorArray.findIndex(
                value => value.name === "Other"
            );

            if (indexPos > -1) {
                colorArray.push(colorArray.splice(indexPos, 1).pop());
            }

            return colorArray;
        },
        isFiltered() {
            return !_.isEmpty(this.value);
        },
    },
    methods: {
        clearAllColors() {
            this.$emit("input", []);
        },
        toggleColor(color) {
            const colorIsAlreadySelected = this.isColorSelected(color);

            if (colorIsAlreadySelected) {
                this.removeColorFromFilters(color);
            } else {
                this.addColorToFilters(color);
            }
        },
        addColorToFilters(color) {
            this.$emit("input", this.value.concat(color.name));
        },
        removeColorFromFilters(color) {
            this.$emit(
                "input",
                this.value.filter(colorName => colorName !== color.name)
            );
        },
        isColorSelected(color) {
            return _.includes(this.value, color.name);
        }
    }
};
</script>
